import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import TextAreaFieldGroup from '../common/TextAreaFieldGroup';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createTicket } from '../../actions/ticketActions';
import { Container, Row, Col } from 'react-bootstrap';
import { Card } from '../Card/Card';
import { getClientsNameAndId } from '../../actions/clientActions';
import { getDevices, getDeviceById, getClientsDevices } from '../../actions/deviceActions';
import classnames from 'classnames';
import Select from 'react-select';
import TextFieldGroup from '../common/TextFieldGroup';
import isEmpty from '../../validation/is-empty';

class AddTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      part: '',
      search: '',
      client: '',
      device: '',
      priority: '',
      status: '',
      desc: '',
      service: '',
      errors: {},
      selectedOption: null,
      selectedDevice: null
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    if (this.props.auth.user.position === 'Klijent') {
      this.props.history.push('/dashboardclient');
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  onSubmit(e) {
    e.preventDefault();
    const ticketData = {
      device: this.state.device,
      priority: this.state.priority,
      status: this.state.status,
      service: this.state.service,
      desc: this.state.desc,
      client: this.state.client,
      user: this.props.auth.user.id,
    };
    console.log(ticketData);

    this.props.createTicket(ticketData, this.props.history);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  getClientData(){
    this.props.getClientsNameAndId(this.state.part)
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption });
    this.setState({ client: selectedOption !== null ? selectedOption.value : '' }, () => { 
      if( selectedOption !== null) {
        console.log(selectedOption.value)
        this.props.getClientsDevices(selectedOption.value)
      }
    });
  };

  handleChangeDevice = selectedDevice => {
    this.setState({ selectedDevice });
    this.setState({ device: selectedDevice !== null ? selectedDevice.value : '' });
    this.setState({ service: selectedDevice !== null ? selectedDevice.service : '' });
  };

  render() {
    const { clientsNai } = this.props.client;
    const { errors } = this.state;
    const { selectedOption, selectedDevice } = this.state;

    const optionsClient = clientsNai.map(client => ({
      label: client.name,
      value: client._id
    }));

    console.log(this.props.device.clientsDevices);
    const devices = this.props.device.clientsDevices.filter(devices => {
      return !isEmpty(this.state.client)
        ? devices.client.indexOf(this.state.client) !== -1
        : devices;
    });

    const optionDevices = devices.map(device => ({
      label: device.ibfk + ', ' + device.address + ', ' + device.city,
      service: device.service,
      value: device._id
    }));

    return (
      <div className="content">
        <Container fluid>
          <Row>
            <Col md={8}>
              <Card
                title="Novi tiket"
                category="Kreiraj tiket"
                content={
                  <form onSubmit={this.onSubmit}>
                    <div className="row">
                      <div className="col-md-4">
                        <label className="control-label">Pib</label>
                        <TextFieldGroup
                          type="text"
                          placeholder="pib"
                          name="part"
                          value={this.state.part}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type='button'
                          value="pretrazi"
                          onClick={this.getClientData.bind(this)}
                          className="btn-fill col-md-12 pull-center btn btn-info"
                          style={{ margin: '3px',marginTop: '28px' }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <label className="control-label">Klijent</label>
                        <Select
                          defaultValue=""
                          placeholder="Selektuj Klijenta..."
                          isClearable
                          name='search'
                          value={selectedOption}
                          onChange={this.handleChange}
                          options={optionsClient}
                          error={errors.clientticket}
                        />
                        <div className="text-danger">{errors.clientticket}</div>
                      </div>
                      <div className="col-md-6">
                        <label className="control-label">Uredjaj</label>
                        <Select
                          isClearable
                          placeholder="Selektuj Uredjaj..."
                          value={selectedDevice}
                          onChange={this.handleChangeDevice}
                          options={optionDevices}
                        />
                        <div className="text-danger">{errors.deviceticket}</div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="control-label">PRIORITET</label>
                        <select
                          className={classnames('form-control', {
                            'is-invalid': errors.priority
                          })}
                          name="priority"
                          value={this.state.priority}
                          onChange={this.onChange}
                        >
                          <option value="">* Selektuj Prioritet</option>
                          <option value="1">Low</option>
                          <option value="2">Medium</option>
                          <option value="3">High</option>
                          <option value="4">Urgent</option>
                        </select>
                        <div className="text-danger">
                          {errors.priorityticket}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="control-label">Status</label>
                        <select
                          className={classnames('form-control', {
                            'is-invalid': errors.status
                          })}
                          name="status"
                          value={this.state.status}
                          onChange={this.onChange}
                        >
                          <option value="">* Selektuj Status</option>
                          <option value="1">Novi</option>
                          <option value="2">Na cekanju</option>
                          <option value="3">U toku</option>
                          <option value="4">Zavrsen</option>
                          <option value="5">Otkazan</option>
                        </select>
                        <div className="text-danger">{errors.statusticket}</div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <TextAreaFieldGroup
                          label="Opis kvara/Komentar"
                          placeholder="Opis kvara/Komentar"
                          name="desc"
                          value={this.state.desc}
                          onChange={this.onChange}
                          error={errors.descticket}
                          rows={5}
                        />
                        <div className="text-info">
                          {this.state.desc.length}/1500
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <input
                          type="submit"
                          value="Sacuvaj"
                          className="btn-fill col-md-12 pull-center btn btn-info"
                          style={{ margin: '3px' }}
                        />
                      </div>
                      <div className="col-md-6">
                        <Link
                          to="/tickets"
                          className="btn-fill col-md-12 btn pull-center btn-default"
                          style={{ margin: '3px' }}
                        >
                          Nazad na Tikete
                        </Link>
                      </div>
                    </div>
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

AddTicket.propTypes = {
  getDevices: PropTypes.func.isRequired,
  getClientsNameAndId: PropTypes.func.isRequired,
  getDeviceById: PropTypes.func.isRequired,
  getClientsDevices: PropTypes.func.isRequired,
  createTicket: PropTypes.func.isRequired,
  device: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  device: state.device,
  errors: state.errors,
  client: state.client,
  clientsNai: state.clientsNai,
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { createTicket, getClientsNameAndId, getDevices, getDeviceById, getClientsDevices }
)(withRouter(AddTicket));
